<template>
    <div id="facility-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                    
                </div>
                <div class="modal-body">
                    <div class="form-row mb-2">
                        <input type="text" class="form-control" placeholder="Name" v-model="facility.name">
                    </div>
                    <div class="form-row mb-2">
                        <input type="text" class="form-control" placeholder="Address" v-model="facility.address">
                    </div>
                    <div class="form-row mb-2">
                        <input type="text" class="form-control" placeholder="City" v-model="facility.city">
                    </div>
                    <div class="form-row mb-2">
                        <select v-bind:class="['custom-select', { 'text-muted' : facility.state == 'None' }]" v-model="facility.state">
                            <option disabled value="None" hidden>State</option>
                            <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
                        </select>
                    </div>
                    <div class="form-row mb-2">
                        <input type="text" class="form-control" placeholder="Postal Code" v-model="facility.postal_code">
                    </div>
                    <div class="form-row">
                        <telephone-input id="phone_number" class="form-control" placeholder="Phone Number" v-model="facility.phone_number"></telephone-input>
                    </div>                                 
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    props: {
        states: Array
    },
    data() {
        return {
            title: '',
            href: '',
            facility: {
                npi: 0,
                name: '',
                address: '',
                city: '',
                state: 'None',
                postal_code: '',
                phone_number: ''
            }
        }
    },
    methods: {
        addFacility: function (npi) { 
            this.title = 'Add Facility';
            this.href = '/ajax/providers/' + npi + '/facilities';
            this.facility.name = '';
            this.facility.address = '';
            this.facility.city = '';
            this.facility.state = 'None';
            this.facility.postal_code = '';
            this.facility.phone_number = '';            
            $('#facility-modal').modal('show');
        },
        editFacility: function (facility) {
            this.title = 'Edit Facility';
            this.href = '/ajax/providers/' + facility.npi + '/facilities/' + facility.id;
            Object.assign(this.facility, facility);
            $('#facility-modal').modal('show');
        },
        save: function () {
            if (this.title === 'Add Facility') {

                axios.post(this.href, {
                    'facility': this.facility
                })
                .then(response => {
                    eventHub.$emit('facility-event');
                    $('#facility-modal').modal('hide');
                })
                .catch(error => {
                    console.log(error.response.data);
                     $('#facility-modal').modal('hide');
                });
            }
            else if (this.title === 'Edit Facility') {

                axios.patch(this.href, {
                    'facility': this.facility
                })
                .then(response => {
                    eventHub.$emit('facility-event');
                    $('#facility-modal').modal('hide');
                })
                .catch(error => {
                    console.log(error.response.data);
                     $('#facility-modal').modal('hide');
                });
            }
        }
    },
    created() {
        eventHub.$on('add-facility', this.addFacility);        
        eventHub.$on('edit-facility', this.editFacility); 
    },
    beforeDestroy() {
        eventHub.$off('add-facility');
        eventHub.$off('edit-facility');
    }      
}
</script>

<style scoped>

</style>